<template>
    <div class="rr-shopping-cart uk-position-relative" uk-grid>
        <div class="uk-width-1-1">
            <loader :visible="showLoader"></loader>
            <table class="rr-shopping-cart__list uk-table uk-table-middle uk-table-divider uk-table-responsive" v-if="cart && cart.items.length">
                <thead>
                    <tr>
                        <th></th>
                        <th>{{ $t('rubinred.ecommerce.orders.common.product') }}</th>
                        <th>{{ $t('rubinred.ecommerce.orders.common.options') }}</th>
                        <th>{{ $t('rubinred.ecommerce.orders.common.quantity') }}</th>
                        <th>{{ $t('rubinred.ecommerce.orders.common.price') }}</th>
                        <th class="uk-text-right@m">{{ $t('rubinred.ecommerce.orders.common.total_amount') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <rubinred-cart-item v-for="item in cart.items" :key="item.id" :item="item"></rubinred-cart-item>
                </tbody>
            </table>
            <div class="rr-shopping-cart__alert uk-alert-primary" uk-alert v-else>
                <i class="fal fa-info-circle uk-margin-small-right"></i> {{ $t('rubinred.ecommerce.orders.common.cart_empty_text') }}
            </div>
        </div>

        <div class="uk-width-1-1" v-if="cart && cart.items.length">
            <div uk-grid>
                <div class="uk-width-3-5@m">
                    <div class="uk-child-width-1-1 uk-grid-medium" uk-grid>
                        <div>
                            <div class="rr-shopping-cart__gift uk-card uk-card-default uk-card-body uk-card-small">
                                <p class="uk-text-bold uk-margin-small-bottom">
                                    {{ $t('rubinred.ecommerce.orders.common.gift_options') }}
                                </p>
                                <label>
                                    <input class="uk-checkbox" type="checkbox" :checked="cart.group_gifts" @change="updateGift">
                                    {{ $t('rubinred.ecommerce.orders.common.is_gift_grouped') }}
                                </label>
                            </div>
                        </div>
                        <div>
                            <rubinred-cart-coupons :coupons="cart.coupons"></rubinred-cart-coupons>
                        </div>
                    </div>
                </div>
                <div class="uk-width-2-5@m">
                    <div class="uk-child-width-1-1" uk-grid>
                        <div>
                            <div class="rr-shopping-cart-resume">
                                <ul class="rr-shopping-cart-resume__totals-list uk-list">
                                    <li>
                                        <div class="uk-flex uk-flex-middle uk-flex-between">
                                            <span>{{ $t('rubinred.ecommerce.orders.common.subtotal') }}</span>
                                            <strong>{{ Utils.Currencies.toHuman(cart.subtotal) }}</strong>
                                        </div>
                                    </li>
                                    <li v-if="cart.shipping_total > 0">
                                        <div class="uk-flex uk-flex-middle uk-flex-between">
                                            <span>{{ $t('rubinred.ecommerce.orders.common.shipping') }}</span>
                                            <strong>{{ Utils.Currencies.toHuman(cart.shipping_total) }}</strong>
                                        </div>
                                    </li>
                                    <li v-if="cart.payment_total > 0">
                                        <div class="uk-flex uk-flex-middle uk-flex-between">
                                            <span>{{ $t('rubinred.ecommerce.orders.common.payment') }}</span>
                                            <strong>{{ Utils.Currencies.toHuman(cart.payment_total) }}</strong>
                                        </div>
                                    </li>
                                    <li v-if="cart.discount_total < 0">
                                        <div class="uk-flex uk-flex-middle uk-flex-between">
                                            <span>{{ $t('rubinred.ecommerce.orders.common.discount') }}</span>
                                            <strong>{{ Utils.Currencies.toHuman(cart.discount_total) }}</strong>
                                        </div>
                                    </li>
                                </ul>
                                <div class="rr-shopping-cart-resume__total uk-flex uk-flex-middle uk-flex-between">
                                    <strong>{{ $t('rubinred.ecommerce.orders.common.order_total') }}</strong>
                                    <strong>{{ Utils.Currencies.toHuman(cart.total) }}</strong>
                                </div>
                            </div>
                        </div>
                        <div>
                            <a :href="checkoutEndpoint" class="rr-shopping-cart__cta uk-button uk-button-large uk-button-primary uk-width-1-1">
                                {{ $t('rubinred.ecommerce.orders.action.checkout') }}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    props: {
      checkoutEndpoint: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        showLoader: false,
      };
    },
    computed: {
      cart() {
        return this.$store.state.cart.cart;
      },
    },
    mounted() {
      this.$store.subscribeAction({
        before: () => {
          this.showLoader = true;
        },
        after: () => {
          this.showLoader = false;
        }
      })
    },
    methods: {
      updateGift() {
        this.$store.dispatch('cart/updateGiftSettings', {name: 'group-gifts', active: !this.cart.group_gifts});
      }
    }
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/ecommerce/assets/js/components/cart/RubinredCart.vue